import { GoogleLogin } from '@react-oauth/google';
import { lazy, memo, Suspense, useContext, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch, useSelector } from 'react-redux';
import phoneImage from '../assets/phone.png';
import smsImage from '../assets/sms.png';
import zaloImage from '../assets/zalo.png';
import Loading from '../components/layouts/Loading';
import { AuthContext } from '../contexts/AuthContext';
import { getCategories } from '../redux/actions/categories';
import {
  getLatestProducts,
  getProducts,
  getTopDiscountProducts,
  getTopRatingProducts,
} from '../redux/actions/products';
import { categories$, products$ } from '../redux/selectors';

const Banner = lazy(() => import('../components/home/Banner'));
const Categories = lazy(() => import('../components/home/Categories'));
const Featured = lazy(() => import('../components/home/Featured'));
const Hero = lazy(() => import('../components/home/Hero'));
const LatestProduct = lazy(() => import('../components/home/LatestProduct'));
const Blog = lazy(() => import('../components/home/Blog'));

const Home = () => {
  const dispatch = useDispatch();
  const products = useSelector(products$);
  const categories = useSelector(categories$);
  const {
    authState: { isAuthenticated },
    loginUser,
  } = useContext(AuthContext);

  useEffect(() => {
    if (categories.data.length === 0) {
      dispatch(getCategories.getCategoriesRequest());
    }
    if (products.data.length === 0) {
      dispatch(getProducts.getProductsRequest());
    }
    if (products.latestProducts.length === 0) {
      dispatch(getLatestProducts.getLatestProductsRequest());
    }
    if (products.topRatingProducts.length === 0) {
      dispatch(getTopRatingProducts.getTopRatingProductsRequest());
    }
    if (products.topDiscountProducts.length === 0) {
      dispatch(getTopDiscountProducts.getTopDiscountProductsRequest());
    }

    if (process.env.NODE_ENV === 'production') {
      if (window.FB) {
        window.FB.XFBML.parse();
      }
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.REACT_APP_FACEBOOK_APP_ID,
          autoLogAppEvents: true,
          cookie: true,
          xfbml: true,
          version: 'v14.0',
        });
      };
      var chatbox = document.getElementById('fb-customer-chat');
      chatbox?.setAttribute('page_id', process.env.REACT_APP_FACEBOOK_PAGE_ID);
      chatbox?.setAttribute('attribution', 'biz_inbox');
      (function (d, s, id) {
        if (d.getElementById(id)) return;
        var js,
          fjs = d.getElementsByTagName(s)[0];
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/vi_VN/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
    return () => {
      document.getElementById('facebook-jssdk')?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ overflowX: 'hidden' }}>
      {!isAuthenticated && (
        <div
          style={{
            position: 'fixed',
            zIndex: 2,
            display: 'flex',
            left: '20px',
            bottom: '20px',
          }}
        >
          <GoogleLogin
            onSuccess={async (credentialResponse) =>
              await loginUser(
                {
                  username: '',
                  password: '',
                },
                credentialResponse
              )
            }
            onError={(error) => {
              console.log(error);
            }}
            useOneTap
          />
        </div>
      )}
      <div className="support_lindo_2022">
        <ul className="group_suport">
          <li className="item_support">
            <a rel="noreferrer" target="_blank" href="tel:0934942127">
              {/* <img
                width="50"
                height="50"
                className="phone_img entered lazyloaded"
                title="Gọi Điện"
                src={phoneImage}
                data-ll-status="loaded"
                alt=""
              /> */}
              <LazyLoadImage
                className="phone_img entered lazyloaded"
                effect="blur"
                src={phoneImage}
                alt="Gọi Điện"
                width="50px"
                height="50px"
                placeholderSrc="img/logo.png"
              />
            </a>
          </li>
          <li className="item_support">
            <a
              rel="noreferrer"
              target="_blank"
              href="http://zalo.me/0934942127"
            >
              {/* <img
                width="50"
                height="50"
                title="Chat Zalo"
                className="phone_img entered lazyloaded"
                src={zaloImage}
                data-ll-status="loaded"
                alt=""
              /> */}
              <LazyLoadImage
                className="phone_img entered lazyloaded"
                effect="blur"
                src={zaloImage}
                alt="Chat Zalo"
                width="50px"
                height="50px"
                placeholderSrc="img/logo.png"
              />
            </a>
          </li>
          <li className="item_support">
            <a rel="noreferrer" target="_blank" href="sms:0934942127">
              {/* <img
                width="50"
                height="50"
                className="phone_img entered lazyloaded"
                title="Nhắn tin"
                src={smsImage}
                data-ll-status="loaded"
                alt=""
              /> */}
              <LazyLoadImage
                className="phone_img entered lazyloaded"
                effect="blur"
                src={smsImage}
                alt="Nhắn tin"
                width="50px"
                height="50px"
                placeholderSrc="img/logo.png"
              />
            </a>
          </li>
        </ul>
      </div>
      <Suspense fallback={<Loading />}>
        <Hero />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Categories categories={categories} />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Featured products={products} />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Banner />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <LatestProduct products={products} />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Blog />
      </Suspense>

      {process.env.NODE_ENV === 'production' && (
        <div>
          <div id="fb-root"></div>
          <div id="fb-customer-chat" className="fb-customerchat"></div>
        </div>
      )}
    </div>
  );
};

export default memo(Home);
